import React, { useEffect, useRef, useState } from "react";
import './PackageInquiry.css'
import OdooService from '../../services/odooService';
import { useNavigate } from "react-router-dom";
import ErrorModal from "../../components/ErrorModal/ErrorModal";
import LoadingOverlay from "../../components/LoadingOverlay/LoadingOverlay";

const PackageInquiry = ({onPackageScanned}) => {
    const navigate = useNavigate();
    const handleBack = () => navigate(-1);
    const [barcode, setBarcode] = useState('');
    const [packageInfo, setPackageInfo] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const inputRef = useRef(null);
    const scanInputRef = useRef(null);
    const scanTimer = useRef(null);

    useEffect(() => {
        if (inputRef.current) {
            scanInputRef.current.focus()
        }
    }, []);

    useEffect(() => {
        if (error === "" && inputRef.current) {
            setTimeout(() => {
                scanInputRef.current.focus();
            }, 50);
        } else  {
            if (inputRef.current) inputRef.current.value = ""; 
        }
    }, [error])

    const handleInputChange = (e) => {
        const value = e.target.value;
        setBarcode(value);

        if (!value) {
            setPackageInfo(null);
            setError('');
        }

        if (scanTimer.current) clearTimeout(scanTimer.current);
        scanTimer.current = setTimeout(() => {
            if (value.trim() !== "") {
                fetchPackageInfo(value.trim());
            }
        }, 120);
    };

    const handleEnterFromDisplayInput = (e) => {
        if (e.key === "Enter") {
            e.preventDefault();

            // Usamos el valor del input visible (inputRef)
            const code = inputRef.current.value.trim();

            if (code !== "") {
                fetchPackageInfo(code);
            }

            inputRef.current.value = "";
        }
    };

    const handleScannerKeyEvents = (e) => {
        if (e.key === "Backspace" || e.keyCode === 8) {
            e.preventDefault();
            return;
        }

        if (e.key === "BrowserBack" || e.keyCode === 4) {
            e.preventDefault();
            return;
        }

        if (e.key === "Enter" || e.keyCode === 13) {
            e.preventDefault();
            return;
        }

        if (e.key.length > 1) {
            e.preventDefault();
            return;
        }
    };

    const fetchPackageInfo = async (code) => {
        setLoading(true);
        setError('');
        setPackageInfo(null);

        try {
            const result = await OdooService.packageInquiry(code);
            
            if (result.success) {
                setPackageInfo(result.package);
                setError('');
                setBarcode('');
                setTimeout(() => scanInputRef.current?.focus(), 10);
            } else {
                setError(result.message || 'Error al consultar el paquete');
                setBarcode('');
            }
        } catch (err) {
            setError('Error de conexión al consultar el paquete');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="package-inquiry-container">
            <header className="package-inquiry-header">
                <h1>Consulta de Paquete</h1>
                <p>Escanee el código del paquete</p>
            </header>

            <div className="package-inquiry-content">
                <div className="package-inquiry-card">

                    <div className="package-inquiry-input-group">
                        <input
                            ref={inputRef}
                            type="text"
                            className="package-inquiry-input"
                            placeholder="Escanea o digita el codigo"
                            disabled={loading}
                            onKeyDown={handleEnterFromDisplayInput}
                            inputMode="text" 
                            onFocus={(e) => e.target.select()} 
                        />

                        <input
                            ref={scanInputRef}
                            className="package-inquiry-scaninput"
                            type="text"
                            value={barcode}
                            onChange={handleInputChange}
                            onKeyDown={handleScannerKeyEvents}
                            autoFocus
                            inputMode="none"
                        />
                    </div>

                    {packageInfo && (
                        <div className="package-inquiry-info">
                            <strong>Código Escaneado:</strong>
                            <p>{packageInfo.name}</p>
                            <strong>Ubicación:</strong>
                            <p>{packageInfo.location_id}</p>
                            <strong>Estado:</strong>
                            <p>{packageInfo.state}</p>
                            <strong>Producto/s:</strong>
                            <div>
                            {packageInfo.products.map((p, i) => (
                                <p key={i}>{p}</p>
                            ))}
                            </div>
                            <strong>Cajas Disponibles:</strong>
                            <p>{packageInfo.available_boxes}</p>
                            <strong>Peso Total:</strong>
                            <p>{packageInfo.total_weight_boxes}-{packageInfo.measurement}</p>
                        </div>
                    )}
                </div>
            </div>

            <div className="package-inquiry-actions">
                <button onClick={handleBack} className="package-inquiry-btn package-inquiry-btn-secondary">
                    Volver
                </button>
            </div>

            {loading && (
                <div className="loading-overlay">
                    <div className="spinner"></div>
                    <p>Cargando...</p>
                </div>
            )}

            {loading && <LoadingOverlay message="Consultando paquete..." />}

            <ErrorModal message={error} onClose={() => setError("")} />
        </div>
    );
};

export default PackageInquiry;